export default __webpack_public_path__ + "static/media/logo-sm.fa13adae.png";